import Title from "@components/text/title";
import Subtitle from "@components/text/subtitle";
import { Container, Row, Col } from "react-bootstrap";
import { ReactNode } from "react";

interface ErrorProps {
  children?: ReactNode | null;
  before?: ReactNode | null;
  title?: string;
  message?: string;
}

/**
 * Error component to display error messages with a title and optional content.
 */
const Error: React.FC<ErrorProps> = ({ children = null, before = null, title = "Erro", message = "" }) => {
  return (
    <main className="error-wrapper p-4 h-full d-flex align-items-center">
      <Container className="text-center">
        { before && <Row><Col className="pt-5">{before}</Col></Row> }
        <Row>
          <Col>
            <Title>{title}</Title>
            <Subtitle className="pt-3">{message}</Subtitle>
          </Col>
        </Row>
        { children && <Row><Col className="pt-5">{children}</Col></Row> }
      </Container>
    </main>
  );
};

export default Error;
